import { useEffect, useMemo, useState } from 'react';
import { normalizePost, getStrapiBaseUrl, getStrapiHeaders } from './useStrapiPosts';

const buildDetailUrl = (slug) => {
  const base = getStrapiBaseUrl();
  if (!base || !slug) {
    return null;
  }

  return `${base.replace(/\/$/, '')}/api/blog-posts?filters[slug][$eq]=${encodeURIComponent(slug)}&populate[heroImage][fields][0]=url`;
};

export function useStrapiPost(slug) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const url = useMemo(() => buildDetailUrl(slug), [slug]);

  useEffect(() => {
    if (!url) {
      setLoading(false);
      return;
    }

    let active = true;

    fetch(url, {
      headers: getStrapiHeaders(),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Unable to load blog post');
        }
        return res.json();
      })
      .then((data) => {
        if (!active) return;
        const entry = data?.data?.[0];
        if (!entry) {
          throw new Error('Post not found');
        }
        setPost(normalizePost(entry));
      })
      .catch((fetchError) => {
        if (!active) return;
        console.error('Strapi post error', fetchError);
        setError(fetchError);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [url]);

  return { post, loading, error };
}
